import EventAccessCode, {
    generateFormFieldPrefix as getEventAccessCodeFormFieldName,
    isStepOneValid,
} from './StepOne/EventAccessCode';
import ReviewAndJoin, {
    generateFormFieldPrefix as getReviewFormFieldName,
    isStepTwoValid,
} from './StepTwo/ReviewAndJoin';

export default {
    StepOne: {
        EventAccessCode,
        isStepOneValid,
        getEventAccessCodeFormFieldName,
    },
    StepTwo: {
        ReviewAndJoin,
        isStepTwoValid,
        getReviewFormFieldName,
    },
};
